import React, {useState} from "react";
import {Card, Container, Row, Col, Form, Button} from "react-bootstrap";
import HeroSection from "../../../../components/HeroSection.jsx";

export function ReportPageShell({title, subtitle, onRun, children, accent = "admin"}) {
    return (
        <Container className="dashboard-shell">
            <HeroSection
                accent={accent}
                eyebrow="Reports"
                title={title}
                subtitle={subtitle}
            />
            {children}
        </Container>
    );
}

export function DateRangeFilter({dateFrom, dateTo, onChange, onApply}) {
    return (
        <Card className="dashboard-panel mt-3">
            <Card.Header className="bg-white"><strong>Filters</strong></Card.Header>
            <Card.Body>
                <Row className="g-3 align-items-end">
                    <Col md={3}>
                        <Form.Label>Date From</Form.Label>
                        <Form.Control type="date" value={dateFrom} onChange={(e) => onChange("dateFrom", e.target.value)} />
                    </Col>
                    <Col md={3}>
                        <Form.Label>Date To</Form.Label>
                        <Form.Control type="date" value={dateTo} onChange={(e) => onChange("dateTo", e.target.value)} />
                    </Col>
                    <Col md="auto">
                        <Button variant="primary" onClick={onApply}>Run</Button>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}
